import { colors } from '@smartsheet/lodestar-core';
import { Icon } from '@smartsheet/lodestar-icons';
import React, { useState } from 'react';
import { Handle, NodeProps, Position } from 'react-flow-renderer';
import { useSelector } from 'react-redux';
import { selectedElementSelector } from '../../../../services/ducks/designerDuck/designerDuck';
import { WorkflowStateNode } from '../../../../services/ducks/workflowDuck/workflowDuck';
import { NODE_HEIGHT } from '../../../../utils/dimensions';
import { useCanNodeBeDeleted } from '../../../../utils/useCanNodeBeDeleted';
import { DragHandleIcon } from '../../../icons/DragHandleIcon';
import { JunctionIcon } from '../../../icons/JunctionIcon';
import { RemoveNodeButton } from './RemoveNodeButton';
import { IconBox, Label, Node } from './styled';

type JunctionNodeData = {
  data: WorkflowStateNode;
  label: JSX.Element;
};

// A Junction has a target handle and a source handle
export const Junction = ({
  data,
  forReactFlow = true,
}: NodeProps<JunctionNodeData> & { forReactFlow: boolean }) => {
  const [hover, setHover] = useState<boolean>(false);
  const selectedElement = useSelector(selectedElementSelector);
  const canNodeBeDeleted = useCanNodeBeDeleted(data.data.id, data.data.type);

  return (
    <Node
      selected={selectedElement?.id === data.data.id}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {forReactFlow ? (
        <Handle
          type="target"
          position={Position.Top}
          isConnectable={true}
          style={{ visibility: 'hidden', left: NODE_HEIGHT / 2 }}
        />
      ) : null}
      <IconBox color={colors.visBerry} hover={hover}>
        <Icon
          svgComponent={hover ? DragHandleIcon : JunctionIcon}
          size={'xxSmall'}
        />
      </IconBox>
      <Label selected={selectedElement?.id === data.data.id}>
        {data.label}
      </Label>
      {forReactFlow ? (
        <Handle
          type="source"
          position={Position.Bottom}
          isConnectable={true}
          style={{ visibility: 'hidden', left: NODE_HEIGHT / 2 }}
        />
      ) : null}
      {(hover || selectedElement?.id === data.data.id) && canNodeBeDeleted ? (
        <RemoveNodeButton node={data.data} />
      ) : null}
    </Node>
  );
};
